import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/hr/" });

export const HumanResourceService = {
  createEmployee: (employeeDetails) => {
    return api.post("/employees", employeeDetails);
  },

  getEmployees: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/employees?${params.toString()}`);
  },

  getEmployeeById: (employeeId, filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/employees/${employeeId}?${params.toString()}`);
  },

  updateEmployee: (employeeId, employeeDetails) => {
    return api.put(`/employees/${employeeId}`, employeeDetails);
  },

  deleteEmployee: (employeeId) => {
    return api.delete(`/employees/${employeeId}`);
  },

  createWork: (workDetails) => {
    return api.post("/works", workDetails);
  },

  createBulkWork: (workDetails) => {
    return api.post("/works/bulk", workDetails);
  },

  getWorks: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/works?${params.toString()}`);
  },

  getWorkById: (workId) => {
    return api.get(`/works/${workId}`);
  },

  updateWork: (workId, workDetails) => {
    return api.put(`/works/${workId}`, workDetails);
  },

  updateBulkWork: (workDetails) => {
    return api.put("/works/bulk", workDetails);
  },

  deleteWork: (workId) => {
    return api.delete(`/works/${workId}`);
  },

  // Worker Particulars
  createWorkerParticular: (details) => {
    return api.post("/worker-particulars", details);
  },

  getWorkerParticulars: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/worker-particulars?${params.toString()}`);
  },

  updateWorkerParticular: (id, details) => {
    return api.put(`/worker-particulars/${id}`, details);
  },

  deleteWorkerParticular: (id) => {
    return api.delete(`/worker-particulars/${id}`);
  },

  // Work Payment (single)
  createWorkPayment: (payload) => {
    return api.post("/work/payment", payload);
  },

  getWorkPayments: (filters = {}) => {
    const params = new URLSearchParams(Object.entries(filters).filter(([_, value]) => value != null && value !== ""));
    return api.get(`/work/payment?${params.toString()}`);
  },

  getWorkPaymentById: (id) => {
    return api.get(`/work/payment/${id}`);
  },

  updateWorkPayment: (id, payload) => {
    return api.put(`/work/payment/${id}`, payload);
  },

  deleteWorkPayment: (id) => {
    return api.delete(`/work/payment/${id}`);
  },

  // Work Payment (weekly / bulk)
  createWeeklyWorkPayment: (payload) => {
    return api.post("/work/payment/weekly", payload);
  },

  updateWeeklyWorkPayment: (sessionId, payload) => {
    return api.put(`/work/payment/weekly/${sessionId}`, payload);
  },

  getWeeklyWorkPaymentPreFetch: (filters = {}) => {
    const params = new URLSearchParams(Object.entries(filters).filter(([_, value]) => value != null && value !== ""));
    return api.get(`/work/payment/weekly/pre-fetch?${params.toString()}`);
  },

  getWeeklyWorkPaymentSessions: (filters = {}) => {
    const params = new URLSearchParams(Object.entries(filters).filter(([_, value]) => value != null && value !== ""));
    return api.get(`/work/payment/weekly?${params.toString()}`);
  },

  getWeeklyWorkPaymentSession: (sessionId) => {
    return api.get(`/work/payment/weekly/${sessionId}`);
  },

  getWorkerWelfareTotal: (workerId) => {
    return api.get(`/work/payment/welfare-total?workerId=${workerId}`);
  },

  payWeeklyWorkPaymentProject: (sessionId, payload) => {
    return api.put(`/work/payment/weekly/${sessionId}/pay-project`, payload);
  },

  setWeeklyWorkPaymentProjectSupervisor: (sessionId, payload) => {
    return api.put(`/work/payment/weekly/${sessionId}/supervisor`, payload);
  },

  deleteWeeklyWorkPaymentSession: (sessionId) => {
    return api.delete(`/work/payment/weekly/${sessionId}`);
  },
};
